import { emailRegEx } from 'ecs-react-components/dist/index.es';

export const getValidations = (minLength, capitalLetters, numbers, specialCharacters) => ({
  email: {
    required: true,
    validateOnBlur: false,
    promise: (fieldName, fieldValue) => (
      new Promise((resolve, reject) => {
        if (fieldValue && !emailRegEx.test(fieldValue)) {
          reject();
        } else {
          resolve();
        }
      })),
  },
  username: {
    required: true,
    validateOnBlur: false,
    minLength: 4,
    maxLength: 100,
    promise: (fieldName, fieldValue) => (
      new Promise((resolve, reject) => {
        if (fieldValue && !/^[a-zA-Z0-9][a-zA-Z0-9@._-]{3,99}$/.test(fieldValue)) {
          reject();
        } else {
          resolve();
        }
      })),
  },
  password: {
    required: true,
    validateOnBlur: false,
    minLength,
    promise: (fieldName, fieldValue) => (
      new Promise((resolve, reject) => {
        if (fieldValue && (fieldValue.match(/[A-Z]/g) || []).length < capitalLetters) {
          reject();
        } else if (fieldValue && (fieldValue.match(/[0-9]/g) || []).length < numbers) {
          reject();
        } else if (fieldValue &&
            (fieldValue.match(/[! @ # $ % & ) ( + ]/g) || []).length < specialCharacters) {
          reject();
        } else if (fieldValue && fieldValue.length < minLength) {
          reject();
        } else {
          resolve();
        }
      })),
  },
  confirmPassword: {
    required: true,
    validateOnBlur: false,
    matchField: 'password',
  },
  checkboxAccept: {
    required: true,
  },
});
